import React from 'react'
import './SEOText.scss'

const SEOText = () => (
  <div className='sd-seo-text'>
    <p className='sd-seo-text-p'>
      At Argos you can do it all online and get same day delivery on 1000’s of products or visit us in one of 100’s of
      stores and get it immediately. With our easy to use Click and Collect service you can be reassured that you will
      not have a wasted journey, at this store or one nearby. We have pick up points and store’s in 100’s of Sainsbury’s
      stores, so be sure to use our&nbsp;
      <a tabIndex='-1' className='sd-seo-text-a' target='_blank' href='//www.argos.co.uk/stores/'>
        Store locator
      </a>
      &nbsp;to find the easiest way to get what you want. So whatever it is you are looking for,&nbsp;
      <a tabIndex='-1' className='sd-seo-text-a' target='_blank' href='//www.argos.co.uk/'>
        shop
      </a>
      &nbsp;with Argos.
      <br /><br />* Please note that these opening times are updated regularly but may change due to unforeseen circumstances.
    </p>
  </div>
)

export default SEOText



// WEBPACK FOOTER //
// ./src/components/SEOText/SEOText.jsx